// utils/order/constants.js

// Base URL cho API
export const API_BASE_URL = "https://api.emboxvn.com";

// Các trạng thái đơn hàng
export const ORDER_STATUSES = {
    NEW: "NEW",
    SHIPPING: "SHIPPING",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    RETURNED: "RETURNED",
    REFUNDED: "REFUNDED",
};

// Màu sắc tương ứng với từng trạng thái
export const ORDER_STATUS_COLORS = {
    NEW: "info",
    SHIPPING: "primary",
    COMPLETED: "success",
    CANCELLED: "error",
    RETURNED: "warning",
    REFUNDED: "secondary",
};

// Các phương thức thanh toán
export const PAYMENT_METHODS = {
    COD: "COD",
    BANK_TRANSFER: "BANK_TRANSFER",
    CREDIT_CARD: "CREDIT_CARD",
    E_WALLET: "E_WALLET",
};

// Số lượng đơn hàng hiển thị trên mỗi trang
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

// API endpoints
export const API_ENDPOINTS = {
    LIST: "/order/list",
    DETAIL: "/order/:id",
    CREATE: "/order/create",
    UPDATE_STATUS: "/order/:id/status",
    SEARCH: "/order/search",
};
